// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active[data-v-6e2a9f70],\n.fade-leave-active[data-v-6e2a9f70],\n.fade-collapse-enter-active[data-v-6e2a9f70],\n.fade-collapse-leave-active[data-v-6e2a9f70] {\n\ttransition: opacity var(--animation-quick), max-height var(--animation-quick);\n}\n.fade-collapse-enter[data-v-6e2a9f70],\n.fade-collapse-leave-to[data-v-6e2a9f70] {\n\topacity: 0;\n\tmax-height: 0;\n}\n.fade-enter[data-v-6e2a9f70],\n.fade-leave-to[data-v-6e2a9f70] {\n\topacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
